import React, { useEffect, useState } from 'react';

import { get } from 'lodash';

import {
  BooleanInput,
  useRecordContext,
} from 'react-admin';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

import InfoPopover from '../../layout/InfoPopover';
import actions, { Actions } from '../../../constants/actions';
import ReportField from './PermissionAttributes/ReportsField';
import ReportInput from './PermissionAttributes/ReportsInput';
import RequirePeerReviewField from './PermissionAttributes/RequirePeerReviewField';
import RequirePeerReviewInput from './PermissionAttributes/RequirePeerReviewInput';
import { AccordionRow } from '../../layout/AccordionV2';

const attributesComponent: Partial<Record<
Actions,
{
  show: React.ComponentType<{ action: Actions }>;
  creation: React.ComponentType<{ action: Actions }>;
}
>> = {
  [actions.REPORT_GET]: {
    show: ReportField,
    creation: ReportInput,
  },
  [actions.REPORT_LIST]: {
    show: ReportField,
    creation: ReportInput,
  },
  [actions.REPORT_CREATE]: {
    show: ReportField,
    creation: ReportInput,
  },
  [actions.REPORT_DOWNLOAD]: {
    show: ReportField,
    creation: ReportInput,
  },
  [actions.RULE_VERSION_PUBLISH]: {
    show: RequirePeerReviewField,
    creation: RequirePeerReviewInput,
  },
  [actions.RULE_VERSION_RELEASE]: {
    show: RequirePeerReviewField,
    creation: RequirePeerReviewInput,
  },
};

const PermissionRow = ({
  label,
  action,
  extraInformation,
  mode,
}: {
  label: string;
  action: Actions;
  extraInformation?: string;
  mode: 'show' | 'creation';
}) => {
  const record = useRecordContext();
  const valueEnabled = get(record, `permissions.${action}.enabled`, false);

  // Delay heavy rendering to let the UI fully update before
  const [shouldRender, setShouldRender] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setShouldRender(true);
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, []);
  if (!shouldRender) return null;

  const actionAttributesComponents = attributesComponent[action];
  const ActionAttributesComponent = actionAttributesComponents
    ? actionAttributesComponents[mode] : null;

  return (
    <AccordionRow>
      <Box display="flex" justifyContent="space-between">
        <Box display="flex" alignItems="center">
          <Typography>{label}</Typography>
          {extraInformation && (
            <InfoPopover
              title={label}
              content={extraInformation}
            />
          )}
        </Box>
        {mode === 'show' && <Switch checked={valueEnabled} disabled />}
        {mode === 'creation' && <BooleanInput source={`permissions.${action}.enabled`} label="" helperText={false} />}
      </Box>
      {ActionAttributesComponent && (
        <ActionAttributesComponent action={action} />
      )}
    </AccordionRow>
  );
};

export default React.memo(PermissionRow);
